export const freefireCalculatorSkillContract = {
  id: 'freefire_calculator',
  version: '1.0.0',
  name: 'Calculadora Free Fire',
  domain: 'fps_mobile',
  supportedGames: ['free_fire'],
  description: 'Calcula uma base de sensibilidade para Free Fire usando aparelho, performance, jogabilidade e problema de mira.',
  intentExamples: [
    'calcula minha sensi no Free Fire',
    'quero uma sensibilidade pro meu celular no FF',
    'minha mira esta puxando no Free Fire',
    'calcula geral e red dot no FF'
  ],
  conversationGroups: [
    {
      id: 'device',
      label: 'aparelho',
      slots: ['platform', 'deviceTier', 'deviceModel', 'ram']
    },
    {
      id: 'performance',
      label: 'performance',
      slots: ['fps', 'hz']
    },
    {
      id: 'gameplay',
      label: 'jogabilidade',
      slots: ['fingers', 'playStyle', 'aimProblem']
    },
    {
      id: 'optional',
      label: 'opcional',
      slots: ['dpi', 'buttonSize', 'currentSens']
    }
  ],
  requiredSlotGroups: ['device', 'performance', 'gameplay'],
  requiredSlots: ['platform', 'ram', 'fps', 'hz', 'fingers', 'playStyle', 'aimProblem'],
  alternativeSlots: {
    deviceTier: ['deviceModel']
  },
  optionalSlots: ['deviceTier', 'deviceModel', 'dpi', 'buttonSize', 'currentSens', 'language', 'requestId'],
  slotSchemas: {
    platform: {
      type: 'enum',
      values: ['android', 'ios']
    },
    deviceTier: { type: 'string' },
    deviceModel: { type: 'string' },
    ram: { type: 'number' },
    fps: { type: 'number' },
    hz: { type: 'number' },
    fingers: { type: 'number' },
    playStyle: { type: 'string' },
    aimProblem: { type: 'string' },
    dpi: {
      type: 'number',
      required: false
    },
    buttonSize: {
      type: 'number',
      required: false
    },
    currentSens: {
      type: 'object',
      required: false
    },
    language: { type: 'string' },
    requestId: { type: 'string' }
  },
  askForMissingSlots: {
    device: 'Me passa o basico do aparelho: Android ou iPhone, RAM e se ele e fraco, medio ou forte.',
    performance: 'Voce joga a quantos FPS e sua tela tem quantos Hz?',
    gameplay: 'Voce joga com quantos dedos, qual seu estilo e qual erro sente na mira?',
    unknownNotAllowed: 'Se nao souber, me da uma aproximacao simples para eu nao calcular no chute.'
  },
  execution: {
    handler: 'FreeFireCalculatorSkillAdapter',
    requiresBackend: true,
    backendAccessRoute: '/api/freefire-calculator/access',
    backendRoute: '/api/freefire-calculator/calculate',
    costClass: 'low',
    requiresCredits: false,
    requiresPlan: 'pro_or_freefire_lifetime'
  },
  output: {
    mode: 'conversation',
    schema: 'calculator_result'
  },
  guardrails: {
    askInShortGroups: true,
    neverAskNineQuestionsAtOnce: true,
    acceptUnknownOnlyWhenBackendHasSafeDefault: true,
    backendCalculatorIsAuthoritative: true,
    freeUsersRemainBlockedUnlessBackendChanges: true,
    doNotPutFormulaInContract: true,
    preserveIdempotencyRequestId: true
  },
  capabilityMapping: {
    primaryCapabilityId: 'calculator_freefire',
    relatedCapabilityIds: []
  }
};

export default freefireCalculatorSkillContract;
